module.exports = __webpack_public_path__ + "img/home_new.198aa19e.svg";